module.exports = __webpack_public_path__ + "static/media/question-mark.e80e5611.svg";